import { toast } from "react-toastify";
import {
  privateAxios,
} from "../../../config/apiConfig";
import {
  ADD_ITEM_TO_WISHLIST_FAILURE,
  ADD_ITEM_TO_WISHLIST_REQUEST,
  ADD_ITEM_TO_WISHLIST_SUCCESS,
  GET_WISHLIST_FAILURE,
  GET_WISHLIST_REQUEST,
  GET_WISHLIST_SUCCESS,
  IS_WISHLIST_ITEM_EXIST_FAILURE,
  IS_WISHLIST_ITEM_EXIST_REQUEST,
  IS_WISHLIST_ITEM_EXIST_SUCCESS,
  REMOVE_WISHLIST_ITEM_FAILURE,
  REMOVE_WISHLIST_ITEM_REQUEST,
  REMOVE_WISHLIST_ITEM_SUCCESS,
} from "./ActionType";

export const getWishlist = () => async (dispatch) => {
  dispatch({ type: GET_WISHLIST_REQUEST });

  try {
    const response = await privateAxios.get(`user/wishlist`);
    dispatch({ type: GET_WISHLIST_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: GET_WISHLIST_FAILURE, payload: error.message });
  }
};

export const isWishlistItemExist = (productId) => async (dispatch) => {
  dispatch({ type: IS_WISHLIST_ITEM_EXIST_REQUEST });
  try {
    const response = await privateAxios.get(`user/wishlistItem/exist/product/${productId}`);
    const exists = response.data;
    dispatch({ type: IS_WISHLIST_ITEM_EXIST_SUCCESS, payload: exists });
    dispatch(getWishlist()); // Refresh wishlist after checking existence
    return exists; // Return true/false
  } catch (error) {
    dispatch({ type: IS_WISHLIST_ITEM_EXIST_FAILURE, payload: error.message });
    return false;
  }
};

export const addItemToWishlist = (productId, cartItemId) => async (dispatch) => {
  dispatch({ type: ADD_ITEM_TO_WISHLIST_REQUEST });

  try {
    const response = await privateAxios.post(
      `user/wishlistItem/add/product/${productId}`
    );
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: ADD_ITEM_TO_WISHLIST_SUCCESS, payload: response.data });
      dispatch(getWishlist()); // Refresh wishlist after adding item
    }
  } catch (error) {
    if (error.response?.data?.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: ADD_ITEM_TO_WISHLIST_FAILURE, payload: error.message });
  }
};

export const removeWishlistItem = (productId) => async (dispatch) => {
  dispatch({ type: REMOVE_WISHLIST_ITEM_REQUEST });

  try {
    const response = await privateAxios.delete(`user/wishlistItem/product/${productId}`);
    if (response?.data?.status === "SUCCESS") {
      dispatch({ type: REMOVE_WISHLIST_ITEM_SUCCESS, payload: productId });
      dispatch(getWishlist()); // Refresh wishlist after adding item
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: REMOVE_WISHLIST_ITEM_FAILURE, payload: error.message });
  }
};
